export default "__VITE_ASSET__dc405156__"